import React from "react";
import {Row} from "react-bootstrap";
import {keydownHandler} from "../utils/commonHelper";

const CancelButton = (props) => {
    const {title, agentConnected, cancelLiveChat} = props;
    return <Row
        className={"message-box cancel-button message-buttons " + (!agentConnected ? "visible" : "hidden")}>
        <a className={"template__href "}
           onKeyDown={keydownHandler}
           tabIndex={0}
           onClick={cancelLiveChat}>
            {
                title ? title : "Cancel Live Chat Request"
            }
        </a>
    </Row>
}

export default CancelButton;
